import { render, staticRenderFns } from "./OverdueFactoringsControllers.vue?vue&type=template&id=6b06f6b6&scoped=true&"
import script from "./OverdueFactoringsControllers.vue?vue&type=script&lang=js&"
export * from "./OverdueFactoringsControllers.vue?vue&type=script&lang=js&"
import style0 from "./OverdueFactoringsControllers.vue?vue&type=style&index=0&id=6b06f6b6&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b06f6b6",
  null
  
)

export default component.exports